import { PartnerType } from "@/app/utils/partners.enum";
import { ProductCatalogItem } from "@/app/services/configService/getProductsCatalog";

interface PartnerImageProps {
  type: PartnerType;
  products?: ProductCatalogItem[];
}

export function PartnerImage({ type, products }: PartnerImageProps) {
  const partner = products?.find((item) => item.key === type);

  if (!partner) return null;

  const image = partner.image;
  const color = partner.color;

  return (
    <div
      className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-lg"
      style={{ backgroundColor: color }}
    >
      {image && (
        <img
          src={image}
          alt={partner.label}
          className="h-full w-full scale-90 object-contain"
        />
      )}
    </div>
  );
}
